import componentHelpers from '@/library/ComponentHelpers';
import { createProvider } from '@/vue-apollo';
import filters from '@/library/filters';
import VueResource from 'vue-resource';
import Modal from '@/library/Modal';
import VueMoment from 'vue-moment';
import store from '@/store/index';
import Toasted from 'vue-toasted';
import Shards from 'shards-vue';
import mainOidc from '@/auth';
import Vue from 'vue';

// Core.
import router from '@/router';
import App from '@/App.vue';
import i18n from './i18n';

// Styles.
import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/scss/main.scss';

Shards.install(Vue);

// Components.
import FormGroup from '@/components/common/form/FormGroup.vue';
import RooshButton from '@/components/common/RooshButton.vue';
import Loader from '@/components/common/Loader.vue';

Vue.component('r-button', RooshButton);
Vue.component('form-group', FormGroup);
Vue.component('loader', Loader);

Vue.config.productionTip = false;

Vue.use(componentHelpers);
Vue.use(VueResource);
Vue.use(VueMoment);
Vue.use(filters);
Vue.use(Modal);

Vue.use(Toasted, {
  theme: 'outline',
  position: 'bottom-right',
  duration: 7500,
  iconPack: 'fontawesome',
  singleton: true,
  icon: 'fw',
  action: {
    icon: 'times-circle',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    },
  },
});

mainOidc.startup().then(ok => {
  if (ok) {
    new Vue({
      router,
      store,
      i18n,
      apolloProvider: createProvider(),

      render: createElement => createElement(App)
    }).$mount('#app');
  }
});
